import { FaTruck } from "react-icons/fa";
import { MdRocketLaunch } from "react-icons/md";
import { TbCertificate, TbDrone } from "react-icons/tb";
import {
  PilotIcon,
  AgriIcon,
  TechnicianIcon,
  SurveyingIcon,
  CameraIcon,
  InspectionIcon,
  CrosshairsIcon,
  ShoppingCartIcon,
  LifeRingIcon,
  FaShieldAlt,
  FaHandshake,
  FaRocket,
  FaGlobe,
  FaUserCheck,
  FaSlidersH,
  FaTags,
  FaCalendarCheck,
  FaPlaneDeparture,
  FaUserTie,
} from "./Icons";
import Drone1 from "../assets/image/png/drone1.avif"
import Drone2 from "../assets/image/png/drone2.avif"
import Drone3 from "../assets/image/png/drone3.avif"
import Drone4 from "../assets/image/png/drone4.avif"
import mapping from "../assets/image/png/surveying.avif"
import dgps from "../assets/image/png/dgps.avif"
import kisan from "../assets/image/png/kisan.avif"
import technician from "../assets/image/png/technician.avif"
import pilot from "../assets/image/png/pilot.avif"
import aerial from "../assets/image/png/aerial-photography.avif"
import inspection from "../assets/image/png/inspection.avif"
import agriculture from "../assets/image/png/agriculture-farm.avif"
 
 
// --- DATA ---
export const trainingItems = [
  {
    id: "pilot",
    title: "Drone Pilot Training",
    description: "Become a certified drone pilot.",
    details: "Master drone operation, safety protocols, and flight planning.",
    img: pilot ,
    icon: <PilotIcon />,
  },
  {
    id: "kisan",
    title: "Kisan Drone Operator",
    description: "Specialize in drone tech for agriculture.",
    details: "Learn precision agriculture techniques using drone technology.",
    img: kisan,
    icon: <AgriIcon />,
  },
  {
    id: "technician",
    title: "Drone Manufacturing & Repair",
    description: "Build, repair, and maintain drones.",
    details: "Gain expertise in building, repairing, and assembling drones.",
    img: technician,
    icon: <TechnicianIcon />,
  },
  {
    id: "dgps",
    title: "DGPS Surveying & GIS Mapping",
    description: "Master land mapping and geospatial analysis.",
    details:
      "Train in land mapping, surveys, and geospatial analysis with drones.",
    img: dgps ,
    icon: <SurveyingIcon />,
  },
];
export const serviceItems = [
  {
    id: "surveying",
    title: "Surveying & Mapping",
    description: "High-precision GIS mapping and 3D modeling.",
    details:
      "Leverage our drones for accurate topographical surveys and detailed 3D asset modeling.",
    img: mapping ,
    icon: <SurveyingIcon />,
  },
  {
    id: "aerial-photography",
    title: "Aerial Photography & Videography",
    description: "Capture breathtaking 4K aerial footage.",
    details:
      "Stunning drone photography for real estate, marketing campaigns, events, and cinematic productions.",
    img: aerial,
    icon: <CameraIcon />,
  },
  {
    id: "inspection",
    title: "Inspection & Surveillance",
    description: "Safe and efficient remote monitoring.",
    details:
      "Conduct detailed inspections of infrastructure like pipelines, power lines, and wind turbines.",
    img: inspection,
    icon: <InspectionIcon />,
  },
  {
    id: "agriculture-farm",
    title: "Agriculture & Farm Solutions",
    description: "Boost crop yield with precision spraying.",
    details:
      "Our services include precision spraying, crop health monitoring, and data-driven insights.",
    img: agriculture,
    icon: <AgriIcon />,
  },
];
 
export const cards = [
  {
    id: 1,
    icon: <TbDrone className="w-[32px] h-[32px]" />,
    title: "Buy Drone & Accessories",
    description:
      "Find the best drone, parts, and accessories at competitive prices.",
    color: "blue",
    link: "/product/all-drone",
    cta: "Shop Now",
  },
  {
    id: 2,
    icon: <MdRocketLaunch className="w-[32px] h-[32px]" />,
    title: "Jobs & Career Opportunities",
    description:
      "Explore exciting drone-related job opportunities across India.",
    color: "teal",
    link: "jobs-hire-page",
    cta: "View Openings",
  },
  {
    id: 3,
    icon: <TbCertificate className="w-[32px] h-[32px]" />,
    title: "Drone Training & Certification",
    description:
      "Get certified with DGCA-approved drone pilot training programs.",
    color: "amber",
    link: "training-courses/0",
    cta: "Explore Courses",
  },
  {
    id: 4,
    icon: <FaTruck className="w-[32px] h-[32px]" />,
    title: "Drone as a Service (DaaS)",
    description:
      "Hire professional drone pilot for mapping, surveillance, and more.",
    color: "rose",
    link: "/daas-service-page",
    cta: "Learn More",
  },
];
 
export const colorVariants = {
  blue: {
    bg: "bg-blue-50",
    text: "text-blue-600",
    shadow: "hover:shadow-blue-200/80",
    border: "group-hover:border-blue-500",
    iconBg: "bg-blue-100",
  },
  teal: {
    bg: "bg-teal-50",
    text: "text-teal-600",
    shadow: "hover:shadow-teal-200/80",
    border: "group-hover:border-teal-500",
    iconBg: "bg-teal-100",
  },
  amber: {
    bg: "bg-amber-50",
    text: "text-amber-600",
    shadow: "hover:shadow-amber-200/80",
    border: "group-hover:border-amber-500",
    iconBg: "bg-amber-100",
  },
  rose: {
    bg: "bg-rose-50",
    text: "text-rose-600",
    shadow: "hover:shadow-rose-200/80",
    border: "group-hover:border-rose-500",
    iconBg: "bg-rose-100",
  },
};
 
export const DroneCategoriesCard = [
  {
    image: Drone1,
    title: "Agriculture Drones",
    description:
      "Agriculture drones improve crop monitoring, irrigation, and spraying, helping farmers increase efficiency and yield.",
    url: "product/663878c233737989010c7fcd#drones",
  },
  {
    image: Drone2,
    title: "Photography Drones",
    description:
      "Photography drones capture high-quality aerial images and videos, making them ideal for professionals and hobbyists alike.",
    url: "product/66386e8c33737989010c7eb0#drones",
  },
  {
    image: Drone3,
    title: "Survey and Inspection Drones",
    description:
      "Survey drones map large areas with precision, while inspections help infrastructure, reducing risk and maintenance costs.",
    url: "product/66386e6233737989010c7ea6#drones",
  },
  {
    image: Drone4,
    title: "Nano Drones",
    description:
      "Nano drones are small, lightweight, and easy to use, making them perfect for indoor flying, training, and recreational use.",
    url: "product/66386e2133737989010c7e9c#drones",
  },
];
 
export const vendorData = [
  {
    title: "Reach Targeted Customers",
    description:
      "Connect with a wide network of drone enthusiasts and professionals.",
    icon: <CrosshairsIcon className="w-6 h-6" />,
  },
  {
    title: "Hassle-Free Selling",
    description:
      "List your products easily with our streamlined onboarding process.",
    icon: <ShoppingCartIcon className="w-6 h-6" />,
  },
  {
    title: "Dedicated Support",
    description: "Benefit from personalized assistance and marketing support.",
    icon: <LifeRingIcon className="w-6 h-6" />,
  },
];
 
// Varients
export const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2 },
  },
};
 
export const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { type: "spring", stiffness: 100 },
  },
};
 
// theme
export const themeStyles = {
  blue: {
    active: "bg-white border-blue-500 shadow-xl scale-[1.05]",
    inactive:
      "bg-white/60 border-transparent hover:bg-white/80 hover:border-blue-400/50 backdrop-blur-sm",
    title: "text-blue-600",
    icon: "text-blue-500",
    focus: "focus-visible:ring-blue-500",
  },
  green: {
    active: "bg-white border-green-500 shadow-xl scale-[1.05]",
    inactive:
      "bg-white/60 border-transparent hover:bg-white/80 hover:border-green-400/50 backdrop-blur-sm",
    title: "text-green-700",
    icon: "text-green-600",
    focus: "focus-visible:ring-green-600",
  },
};
 
export const contactDetails = {
  email: "support@droneplanet.in",
  phone: "+91 97735 71992",
  address:
    "D-1001 Monsoon Breeze, Sector 78, Navrangpur, Gurugram, Haryana – 122004",
  mapsUrl: "https://maps.google.com/?q=Monsoon+Breeze,+Sector+78,+Gurugram",
};
 
export const footerLinks = {
  support: [
    { title: "Privacy Policy", href: "#" },
    { title: "Terms and Conditions", href: "#" },
    { title: "Return Policy", href: "#" },
    { title: "Shipping Policy", href: "#" },
    { title: "FAQs", href: "#" },
  ],
  services: [
    { title: "RPTO Establishment", href: "#" },
    { title: "Drone Services", href: "#" },
    { title: "Training Courses", href: "#" },
  ],
};
 
export const features = [
  { id: "f1", icon: <FaShieldAlt />, title: "All-in-One Platform" },
  { id: "f2", icon: <FaHandshake />, title: "Trusted by Professionals" },
  { id: "f3", icon: <FaRocket />, title: "Cutting-edge Technology" },
  { id: "f4", icon: <FaGlobe />, title: "Nationwide Coverage" },
  { id: "f5", icon: <FaUserCheck />, title: "Certified Professionals" },
  { id: "f6", icon: <FaSlidersH />, title: "Flexible Hiring" },
  { id: "f7", icon: <FaTags />, title: "Cost-Effective" },
  { id: "f8", icon: <FaCalendarCheck />, title: "Easy Booking" },
  { id: "f9", icon: <FaPlaneDeparture />, title: "Practical Learning" },
  { id: "f10", icon: <FaUserTie />, title: "Expert Trainers" },
];